{
  "title": "TextMask.Inspector-Title.TextEffects",
  "section_fill": "TextMask.Inspector-TextEffects.Section-Fill",
  "section_fill_hover": "TextMask.Inspector-TextEffects.Section-Fill.Tooltip",
  "section_fill_media_btn": "TextMask.Inspector-TextEffects.Section-Fill.Media-Button",
  "section_fill_gradiant_btn": "TextMask.Inspector-TextEffects.Section-Fill.Gradient-Button",
  "section_fill_change_media": "TextMask.Inspector-TextEffects.Section-Fill.ChangeMedia.Label-Hover",
  "section_fill_change_gradiant": "TextMask.Inspector-TextEffects.Section-Fill.ChangeGradient.Label-Hover",

  "section_fill_media_hover": "TextMask.Inspector-TextEffects.Section-Fill.MediaButton.Label-Hover",
  "section_fill_gradiant_hover": "TextMask.Inspector-TextEffects.Section-Fill.GradientButton.Label-Hover",

  "section_fill_overlay": "TextMask.Inspector-TextEffects.Section-Fill.ColorOverlay.Label",
  "section_fill_overlay_color": "TextMask.Inspector-TextEffects.Section-Fill.Color.Label",
  "section_fill_overlay_blend": "TextMask.Inspector-TexEffects.Section-Fill.BlendMode.Label",
  "section_fill_overlay_blend_hover": "TextMask.Inspector-TextEffects.Section-Fill.BlendMode.Tooltip",

  "overlay_blend_normal": "TextMask.Inspector-TextEffects.Section-Fill.BlendModeDropdown.Normal",
  "overlay_blend_colorBurn": "TextMask.Inspector-TextEffects.Section-Fill.BlendModeDropdown.ColorBurn",
  "overlay_blend_multiply": "TextMask.Inspector-TextEffects.Section-Fill.BlendModeDropdown.Multiply",
  "overlay_blend_screen": "TextMask.Inspector-TextEffects.Section-Fill.BlendModeDropdown.Screen",
  "overlay_blend_overlay": "TextMask.Inspector-TextEffects.Section-Fill.BlendModeDropdown.Overlay",
  "overlay_blend_darken": "TextMask.Inspector-TextEffects.Section-Fill.BlendModeDropdown.Darken",
  "overlay_blend_lighten": "TextMask.Inspector-TextEffects.Section-Fill.BlendModeDropdown.Lighten",
  "overlay_blend_colorDodge": "TextMask.Inspector-TextEffects.Section-Fill.BlendModeDropdown.ColorDodge",
  "overlay_blend_hardLight": "TextMask.Inspector-TextEffects.Section-Fill.BlendModeDropdown.HardLight",
  "overlay_blend_softLight": "TextMask.Inspector-TextEffects.Section-Fill.BlendModeDropdown.SoftLight",
  "overlay_blend_difference": "TextMask.Inspector-TextEffects.Section-Fill.BlendModeDropdown.Difference",
  "overlay_blend_exclusion": "TextMask.Inspector-TextEffects.Section-Fill.BlendModeDropdown.Exclusion",
  "overlay_blend_hue": "TextMask.Inspector-TextEffects.Section-Fill.BlendModeDropdown.Hue",
  "overlay_blend_saturation": "TextMask.Inspector-TextEffects.Section-Fill.BlendModeDropdown.Saturation",
  "overlay_blend_color": "TextMask.Inspector-TextEffects.Section-Fill.BlendModeDropdown.Color",
  "overlay_blend_luminosity": "TextMask.Inspector-TextEffects.Section-Fill.BlendModeDropdown.Luminosity",

  "section_text": "TextMask.Inspector-TextEffects.Section-Text",
  "section_text_hover": "TextMask.Inspector-TextEffects.Section-Text.Tooltip",
  "section_text_font": "TextMask.Inspector-TextEffects.Section-Text.Font",

  "section_text_fontUpload": "TextMask.Inspector-TextEffects.Section-Text.Font.Upload-Fonts",
  "section_text_fontLanguages": "Languages",

  "section_text_fontSize": "TextMask.Inspector-TextEffects.Section-Text.FontSize",
  "section_text_autoScale": "TextMask.Inspector-TextEffects.Section-Text.Auto-Adjust",

  "section_text_theme_label": "TextMask.Inspector-TextEffects.Section-Text.Theme",
  "section_text_theme_tooltip": "TextMask.Inspector-TextEffects.Section-Text.Theme.Tooltip",
  "section_text_theme_custom": "TextMask.Inspector-TextEffects.Section-Text.Theme.Custom",

  "section_text_styles": "TextMask.Inspector-TextEffects.Section-Text.Styles",
  "section_text_bold": "TextMask.Inspector-TextEffects.Section-Text.Styles.Bold",
  "section_text_italic": "TextMask.Inspector-TextEffects.Section-Text.Styles.Italics",
  "section_text_underline": "TextMask.Inspector-TextEffects.Section-Text.Styles.Underline",
  "section_text_strikethrough": "TextMask.Inspector-TextEffects.Section-Text.Styles.Strikethrough",

  "section_text_alignment": "TextMask.Inspector-TextEffects.Section-Text.Alignment",
  "section_text_align_left": "TextMask.Inspector-TextEffects.Section-Text.Alignment.Label-Hover.Left",
  "section_text_align_center": "TextMask.Inspector-TextEffects.Section-Text.Alignment.Label-Hover.Center",
  "section_text_align_right": "TextMask.Inspector-TextEffects.Section-Text.Alignment.Label-Hover.Right",
  "section_text_align_justify": "TextMask.Inspector-TextEffects.Section-Text.Alignment.Label-Hover.Justify",
  "section_text_LTR": "TextMask.Inspector-TextEffects.Section-Text.Alignment.Label-Hover.LeftToRight",
  "section_text_RTL": "TextMask.Inspector-TextEffects.Section-Text.Alignment.Label-Hover.RightToLeft",

  "section_text_capitalization": "TextMask.Inspector-TextEffects.Section-Text.Capitalization",
  "section_text_case_none": "TextMask.Inspector-TextEffects.Section-Text.Label-Hover.None",
  "section_text_uppercase": "TextMask.Inspector-TextEffects.Section-Text.Labe-Hover.UpperCase",
  "section_text_titlecase": "TextMask.Inspector-TextEffects.Section-Text.Label-Hover.TitleCase",
  "section_text_lowercase": "TextMask.Inspector-TextEffects.Section-Text.Label-Hover.LowerCase",

  "section_text_spacing": "TextMask.Inspector-TextEffects.Section-Text.Spacing",
  "section_text_line_height": "TextMask.Inspector-TextEffects.Section-Text.Spacing.Label-Hover.LineHeight",
  "section_text_letter_spacing": "TextMask.Inspector-TextEffects.Section-Text.Spacing.Label-Hover.CharacterSpacing",

  "section_text_heading": "TextMask.Inspector-TextEffects.Section-Text.HeadingTag",

  "section_shadow": "TextMask.Inspector-TextEffects.Section-Shadow",
  "section_shadow_hover": "TextMask.Inspector-TextEffects.Section-Shadow.Tooltip",
  "section_shadow_enable": "TextMask.Inspector-TextEffects.Section-Shadow.Enable",
  "section_shadow_angle": "TextMask.Inspector-TextEffects.Section-Shadow.Angle",
  "section_shadow_distance": "TextMask.Inspector-TextEffects.Section-Shadow.Distance",
  "section_shadow_blur": "TextMask.Inspector-TextEffects.Section-Shadow.Blur",
  "section_shadow_color_opacity": "TextMask.Inspector-TextEffects.Section-Shadow.ColorOpacity",

  "change_text_direction": "TextEffects.Modal.TextBox.Direction",
  "change_text_direction_LTR": "TextEffects.Modal.TextBox.Direction.LeftToRight.Label-Hover",
  "change_text_direction_RTL": "TextEffects.Modal.TextBox.Direction.RightToLeft.Label-Hover"
}
